// extracted by mini-css-extract-plugin
export default {"listContainer":"ListAndView_listContainer__RQuT3","viewContainer":"ListAndView_viewContainer__OZsJ+"};